import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { data } from 'autoprefixer';
import { HttpService } from '../services/http.service';
import { DistinctValuesResponse } from '../shared/interfaces/distinct-values-response.interface';

@Injectable({ providedIn: 'root' })
export class EntitiesHttpService extends HttpService {
  getFilterDistinctValues(): Observable<DistinctValuesResponse> {
    return this.http.get<DistinctValuesResponse>(
      `${this.baseUrl}entity/filter-distinct-values`,
    );
  }

  createEntity(data: any): Observable<any> {
    return this.http.post<Observable<any>>(`${this.baseUrl}entity`, data);
  }

  updateEntityAddress(payload: {
    entityId: number;
    data: any;
  }): Observable<any> {
    return this.http.patch(
      `${this.baseUrl}entity/address/${payload.entityId}`,
      payload.data,
    );
  }

  updateEntityProperties(payload: {
    entityId: number;
    data: any;
  }): Observable<any> {
    return this.http.patch(
      `${this.baseUrl}entity/properties/${payload.entityId}`,
      payload.data,
    );
  }

  createEntityBanksAccounts(payload: {
    entityRoleId: string;
    data: any;
  }): Observable<any> {
    return this.http.post(
      `${this.baseUrl}entity-banks/accounts/${payload.entityRoleId}`,
      payload.data,
    );
  }

  getBanksList(): Observable<any> {
    return this.http.get(`${this.originatorBaseUrl}banks`);
  }
}
